import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const u = await register(phone, name);
      navigate(u.role === "limited" ? "/my-timecard" : "/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-100 px-4 py-12">
      <div className="w-full max-w-md bg-white border border-zinc-200 rounded-sm p-8">
        <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-zinc-500 mb-2">
          Inventory OS
        </div>
        <h1 className="font-heading text-3xl tracking-tighter font-black text-zinc-950">
          Create account
        </h1>
        <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="register-form">
          <div>
            <Label htmlFor="name" className="text-[10px] tracking-[0.2em] uppercase font-bold text-zinc-600">
              Name
            </Label>
            <Input
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              data-testid="register-name-input"
              className="mt-1 rounded-sm border-zinc-300"
            />
          </div>
          <div>
            <Label htmlFor="phone" className="text-[10px] tracking-[0.2em] uppercase font-bold text-zinc-600">
              Phone number
            </Label>
            <Input
              id="phone"
              type="tel"
              placeholder="555-000-0004"
              required
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              data-testid="register-phone-input"
              className="mt-1 rounded-sm border-zinc-300 font-mono"
            />
          </div>
          {error && (
            <div
              className="text-sm text-red-600 border border-red-200 bg-red-50 px-3 py-2 rounded-sm"
              data-testid="register-error"
            >
              {error}
            </div>
          )}
          <Button
            type="submit"
            disabled={submitting}
            data-testid="register-submit-btn"
            className="w-full rounded-sm bg-[#002FA7] hover:bg-[#002075] text-white font-semibold"
          >
            {submitting ? "Creating..." : "Create account"}
          </Button>
        </form>
        <div className="mt-4 text-sm text-zinc-600">
          Already have an account?{" "}
          <Link to="/login" className="font-semibold text-[#002FA7] hover:underline" data-testid="goto-login">
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
